module.exports = __webpack_public_path__ + "static/media/foto9.fd6dd7b1.JPG";